import type { ReactNode } from "react";
import { Icon } from "./icons";

// Badges, chips + counters — codified from 11-rozetler-etiketler.html. Tier/priority
// badges (Privé carries the star), the outline chip, the semantic success/warning
// pills, and the notification counter. Color is meaningful; the label is the caller's.

export type BadgeVariant = "prive" | "premier" | "standard" | "priority" | "success" | "warning";

export interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
}

export function Badge({ variant, children }: BadgeProps) {
  return (
    <span className={`k-badge k-badge--${variant}`}>
      {variant === "prive" ? (
        <Icon name="star" size={13} strokeWidth={2.3} style={{ color: "var(--k-green)" }} />
      ) : null}
      {children}
    </span>
  );
}

// Outline tag chip (e.g. "# Sağlık", "# Yenileme").
export function Chip({ children }: { children: ReactNode }) {
  return <span className="k-chip">{children}</span>;
}

// A notification counter: an icon with a red count bubble.
export function Counter({
  count,
  icon = "alert",
  max = 99,
}: {
  count: number;
  icon?: Parameters<typeof Icon>[0]["name"];
  max?: number;
}) {
  return (
    <span className="k-counter">
      <Icon name={icon} size={19} strokeWidth={1.8} style={{ color: "var(--k-text-70)" }} />
      {count > 0 ? (
        <span className="k-counter__bubble">{count > max ? `${max}+` : count}</span>
      ) : null}
    </span>
  );
}
